import Glide, { Autoplay, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

((Drupal, Glide, Autoplay, Swipe) => {
  Drupal.behaviors.miniSliders = {
    attach: (context, _settings) => {
      const announcements = context.querySelectorAll('.view-announcements');
      if (announcements.length === 0) {
        return;
      }

      announcements.forEach((announcement) => {
        const content = announcement.querySelector('.view-content');
        if (!content) {
          return;
        }
        new Glide(content, {
          type: 'slider',
          startAt: 0,
          autoplay: 4000,
          hoverpause: true,
          gap: 0,
        }).mount({ Autoplay, Swipe });
      });
    },
  };
})(window.Drupal, Glide, Autoplay, Swipe);
